import React from 'react';
import get_bundle from '../domain/get_bundle';
import Locale from '../domain/Locale';
import Product from '../domain/Product';
import User from '../domain/User';
import { t, props } from 'tcomb-react';
import cx from 'classnames';

@props({
  locale: Locale,
  product: Product,
  user: User,
  order: t.maybe(t.Obj),
  doShow: t.Bool
})
export default class InvoiceForm extends React.Component {

  getValue() {
    return this.refs.InvoiceForm.getValue();
  }

  getTypeForm() {
    return t.struct({
      invoice_name: t.Str,
      invoice_vat: t.Str,
      invoice_address: t.Str,
      invoice_town: t.Str,
      invoice_district: t.Str,
      invoice_zip: t.Str
    }, 'Invoice');
  }

  getOptionsForm() {
    const bundle = get_bundle(this.props.locale).order;

    return {
      config: {horizontal: {
          md: [3, 9],
          sm: [6, 6]
        }
      },
      fields: {
        invoice_name: {
          label: bundle.invoice.name
        },
        invoice_vat: {
          label: bundle.invoice.vat
        },
        invoice_address: {
          label: bundle.invoice.address
        },
        invoice_town: {
          label: bundle.invoice.town
        },
        invoice_district: {
          label: bundle.invoice.district
        },
        invoice_zip: {
          label: bundle.invoice.zip
        }
      }
    };
  }

  getInitialValue() {
    const order = this.props.order;
    return {
      invoice_name: order.invoice ? order.invoice.name : null,
      invoice_vat: order.invoice ? order.invoice.vat : null,
      invoice_address: order.invoice ? order.invoice.address : null,
      invoice_town: order.invoice ? order.invoice.town : null,
      invoice_district: order.invoice ? order.invoice.district : null,
      invoice_zip: order.invoice ? order.invoice.zip : null
    };
  }

  render() {

    const classes = cx({
      'form-horizontal': true,
      'large-hide': !this.props.doShow
    });

    return (
      <div className={classes} id='invoice_form'>
        <form>
          <t.form.Form
            ref="InvoiceForm"
            type={this.getTypeForm()}
            options={this.getOptionsForm()}
            value={this.getInitialValue()} />
        </form>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/InvoiceForm.js
 **/